import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFoundPage() {
    return (
        <>
            <SEO title="404 — Stranica nije pronađena" path="/404" />
            <section className="grid min-h-[70vh] place-items-center pt-[120px] pb-20">
                <div className="container-p text-center">
                    <span className="eyebrow justify-center">404</span>
                    <h1 className="mt-6 font-[Cabinet_Grotesk] text-[clamp(3rem,8vw,7rem)] font-black leading-none uppercase">
                        Ne <span className="text-[hsl(var(--accent))]">postoji.</span>
                    </h1>
                    <p className="mx-auto mt-6 max-w-md text-[hsl(var(--muted-ink))] leading-relaxed">
                        Stranica koju tražite je premještena ili više ne postoji. Vratite se na početnu i pronađite šta vam treba.
                    </p>
                    <div className="mt-10 flex flex-wrap justify-center gap-3">
                        <Link to="/" className="btn btn-primary">Početna stranica</Link>
                        <Link to="/#modeli" className="btn btn-ghost">Modeli ograda</Link>
                    </div>
                </div>
            </section>
        </>
    );
}
